export default {
  dataLoading: false,
  profil: null,
};
